import {
  BanknotesIcon,
  ClipboardDocumentCheckIcon,
  CpuChipIcon,
  ExclamationTriangleIcon,
  PresentationChartLineIcon,
  ServerStackIcon,
  SparklesIcon,
  Squares2X2Icon,
  TableCellsIcon,
  UsersIcon,
} from '@heroicons/react/24/outline';

export const AI_SPEND_BASE = '/admin/ai-spend';

/**
 * The single source of truth for the tab strip and for which filter controls
 * each page is allowed to show.
 *
 * `filters` is not decoration: the filter bar is built from it, so a page
 * physically cannot display a control its endpoint ignores.
 */
export const AI_SPEND_PAGES = [
  {
    path: 'overview',
    label: 'Overview',
    icon: Squares2X2Icon,
    filters: ['range', 'provider', 'feature', 'model', 'organization'],
  },
  {
    path: 'timeline',
    label: 'Timeline',
    icon: PresentationChartLineIcon,
    filters: ['range', 'provider', 'feature', 'model', 'organization'],
  },
  {
    path: 'features',
    label: 'By feature',
    icon: SparklesIcon,
    filters: ['range', 'provider', 'model', 'organization', 'status'],
  },
  {
    path: 'providers',
    label: 'By provider',
    icon: ServerStackIcon,
    filters: ['range', 'feature', 'model', 'organization', 'status'],
  },
  {
    path: 'models',
    label: 'By model',
    icon: CpuChipIcon,
    filters: ['range', 'provider', 'feature', 'organization', 'status'],
  },
  {
    path: 'organizations',
    label: 'By organization',
    icon: ServerStackIcon,
    filters: ['range', 'provider', 'feature', 'model', 'status'],
  },
  {
    path: 'users',
    label: 'By user',
    icon: UsersIcon,
    filters: ['range', 'provider', 'feature', 'model', 'organization', 'search'],
  },
  {
    path: 'sessions',
    label: 'By session',
    icon: ClipboardDocumentCheckIcon,
    filters: ['range', 'provider', 'feature', 'organization', 'search'],
  },
  {
    path: 'errors',
    label: 'Errors',
    icon: ExclamationTriangleIcon,
    // No outcome filter: this page *is* the outcome filter.
    filters: ['range', 'provider', 'feature', 'model', 'organization'],
  },
  {
    path: 'runs',
    label: 'Runs',
    icon: TableCellsIcon,
    filters: [
      'range', 'provider', 'feature', 'model', 'organization', 'status', 'search',
    ],
  },
  {
    path: 'daily',
    label: 'Daily spend',
    icon: BanknotesIcon,
    filters: ['range', 'provider', 'feature', 'organization'],
  },
];

/** Hidden routes still need their filter contract declared. */
export const AI_SPEND_HIDDEN_PAGES = {
  'users/:subjectUuid': { filters: ['range'] },
};

export const findPageByPathname = (pathname) => {
  const suffix = pathname.replace(`${AI_SPEND_BASE}/`, '');
  return (
    AI_SPEND_PAGES.find((page) => suffix === page.path) ||
    // Detail routes inherit the parent tab's chrome but their own filters.
    (suffix.startsWith('users/') ? { ...AI_SPEND_PAGES.find((p) => p.path === 'users'), filters: ['range'] } : null) ||
    AI_SPEND_PAGES[0]
  );
};
